import * as yup from 'yup'

import EventPaymentSettingsModel from '../event-payment-settings/event-payment-settings.model'
import { IModelBaseModel } from '../model-base/model-base.interface'
import { ModelBaseModel } from '../model-base/model-base.model'
import { IEventReviewPublish } from './event-review-publish.interface'
import { EventDetailsModel } from '../event-details/event-details.model'
import { EventStaffModel } from '../event-staff/event-staff.model'
import { EventSchedulingModel } from '../event-scheduling/event-scheduling.model'
import { EventFeesModel } from '../event-fees/event-fees.model'
import { EventPoliciesModel } from '../event-policies/event-policies.model'
import { EventPaperworkModel } from '../event-paperwork/event-paperwork.model'
import { EventTicketingModel } from '../event-ticketing/event-ticketing.model'
import { EventRequiredFieldsModel } from '../event-required-fields/event-required-fields.model'

export class EventReviewPublishModel
  extends ModelBaseModel<IEventReviewPublish>
  implements IModelBaseModel
{
  public v: number
  public id: IEventReviewPublish['id']
  public title: IEventReviewPublish['title']
  public owner: IEventReviewPublish['owner']
  public status: IEventReviewPublish['status']
  public EventFees: IEventReviewPublish['EventFees']
  public EventStaff: IEventReviewPublish['EventStaff']
  public EventTickets: IEventReviewPublish['EventTickets']
  public EventDetails: IEventReviewPublish['EventDetails']
  public EventPolicies: IEventReviewPublish['EventPolicies']
  public EventSchedule: IEventReviewPublish['EventSchedule']
  public EventPaperwork: IEventReviewPublish['EventPaperwork']
  public briefDescription: IEventReviewPublish['briefDescription']
  public EventPaymentSettings: IEventReviewPublish['EventPaymentSettings']
  public EventRequiredFields: IEventReviewPublish['EventRequiredFields']
  public EventQuestions: IEventReviewPublish['EventQuestions']

  public created: Date
  public modified: Date

  public constructor(obj?: IEventReviewPublish) {
    super()
    this.v = obj?.v ?? 1
    this.id = obj?.id ?? null
    this.owner = obj?.owner ?? null
    this.title = obj?.title ?? ''
    this.briefDescription = obj?.briefDescription ?? ''

    this.EventDetails = new EventDetailsModel(obj?.EventDetails).toObject()
    this.EventStaff = new EventStaffModel(obj?.EventStaff).toObject()
    this.EventSchedule = new EventSchedulingModel(obj?.EventSchedule).toObject()
    this.EventFees = new EventFeesModel(obj?.EventFees).toObject()
    this.EventPolicies = new EventPoliciesModel(obj?.EventPolicies).toObject()
    this.EventPaperwork = new EventPaperworkModel(obj?.EventPaperwork).toObject()
    this.EventTickets = new EventTicketingModel(obj?.EventTickets).toObject()
    this.EventRequiredFields = new EventRequiredFieldsModel(obj?.EventRequiredFields).toFirestore()
    this.EventQuestions = obj?.EventQuestions ?? []
    this.EventPaymentSettings = new EventPaymentSettingsModel(obj?.EventPaymentSettings).toObject()

    this.status = obj?.status ?? null

    this.created = this.utcTimestamp({
      key: 'created',
      isTimestamp: true,
      value: obj?.created,
    })

    this.modified = this.utcTimestamp({
      key: 'modified',
      isTimestamp: true,
      changeOnUpdate: true,
      value: obj?.modified,
    })
  }

  static fromFirestoreDoc(doc: any) {
    return new EventReviewPublishModel({
      id: doc.id,
      ...doc.data(),
    })
  }

  static validationSchema() {
    return yup.object({}).required()
  }
}
